import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';

export interface InlineMessageProps {
  type: 'success' | 'error';
  text: string;
  /** Renders a close button when provided. */
  onDismiss?: () => void;
  className?: string;
}

/** Inline success / error banner shown above page content. */
export const InlineMessage: React.FC<InlineMessageProps> = ({ type, text, onDismiss, className }) => {
  const { t } = useTranslation('common');

  return (
    <div
      className={`${styles.message} ${styles[type]}${className ? ` ${className}` : ''}`}
      role={type === 'error' ? 'alert' : 'status'}
    >
      <span className={styles.text}>{text}</span>
      {onDismiss && (
        <button type="button" className={styles.close} onClick={onDismiss} aria-label={t('close')}>
          <i className="icon-xmark" />
        </button>
      )}
    </div>
  );
};

export default InlineMessage;
